import { createTheme } from "@mui/material/styles";

const fontSize = '13px';
const color = '#666666';
const corErro = '#ec6161'; // Tom de erro discreto

// 1. Definição de estilos que se repetem 
const styleOverridesBase = {
    MuiInputBase: { styleOverrides: { input: { fontSize: fontSize } } },
    MuiInputLabel: { styleOverrides: { root: { fontSize: fontSize } } },
    MuiOutlinedInput: { styleOverrides: { notchedOutline: { fontSize: fontSize } } },
    MuiSelect: { styleOverrides: { select: { fontSize: fontSize } } },
    MuiCheckbox: { styleOverrides: { root: { fontSize: fontSize } } },
    MuiRadio: { styleOverrides: { root: { fontSize: fontSize } } },
    MuiFormHelperText: {
        styleOverrides: { root: { fontSize: '10px', marginTop: '2px', marginLeft: '3px' } }
    },
};

// 2. Tema Edição
export const temaEdicao = createTheme({
    palette: {
        error: { main: corErro },
    },
    components: {
        ...styleOverridesBase,
    },
});

// 3. Tema Visualização
export const temaVisualizacao = createTheme({
    palette: {
        error: { main: corErro },
    },
    components: {
        ...styleOverridesBase,
        MuiInputBase: {
            styleOverrides: {
                input: {
                    fontSize: fontSize,
                    "&.Mui-disabled": { color: color, WebkitTextFillColor: color },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: fontSize,
                    "&.Mui-disabled": { color: color },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                input: { color: color },
                notchedOutline: {
                    fontSize: fontSize,
                    "&.Mui-disabled": { borderColor: color },
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    fontSize: fontSize,
                    "&.Mui-disabled": { color: color, WebkitTextFillColor: color },
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    fontSize: fontSize,
                    "&.Mui-disabled": { color: color },
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    fontSize: fontSize,
                    "&.Mui-disabled": { color: color },
                },
            },
        },
    },
});

/* import { createTheme } from "@mui/material/styles";

const fontSize = '13px';
const color = '#666666'

export const temaEdicao = createTheme({
    components: {
        MuiInputBase: {
            styleOverrides: {
                input: {
                    fontSize: fontSize
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline: {
                    fontSize: fontSize
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    fontSize: fontSize
                },
            },
        },

        MuiCheckbox: {
            styleOverrides: {
                root: {
                    fontSize: fontSize
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    fontSize: fontSize
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: fontSize
                },
            },
        },
    },
});

export const temaVisualizacao = createTheme({
    components: {
        MuiInputBase: {
            styleOverrides: {
                input: {
                    "&.Mui-disabled": {
                        color: color,
                        WebkitTextFillColor: color,
                    },
                    fontSize: fontSize
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    "&.Mui-disabled": {
                        color: color,
                    },
                    fontSize: fontSize
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                input: {
                    color: color
                },
                notchedOutline: {
                    "&.Mui-disabled": {
                        borderColor: color,
                    },
                    fontSize: fontSize
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    "&.Mui-disabled": {
                        color: color,
                        WebkitTextFillColor: color,
                    },
                    fontSize: fontSize
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    "&.Mui-disabled": {
                        color: color,
                    },
                    fontSize: fontSize
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    "&.Mui-disabled": {
                        color: color,
                    },
                    fontSize: fontSize
                },
            },
        },

    },
}); */
